import React, { useState, useEffect } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { toast } from "react-toastify";
import { unlock } from "../../Services/UserApi";
import KeyboardComponent from "./keyboards/virtualKeypad";
import { useToken } from "../../Auth/useToken";
import { keyframes } from "@mui/material/styles";
const shake = keyframes`
  0% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  50% { transform: translateX(10px); }
  75% { transform: translateX(-10px); }
  100% { transform: translateX(0); }
`;
function ReloginModal({ open, onClose, openModalTables, parametrages }) {
  const [pin, setPin] = useState("");
  const [showLetters, setShowLetters] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [hasError, setHasError] = useState(false); // New state for error animation
  // Clear PIN when modal opens/closes
  useEffect(() => {
    if (open) {
      setPin("");
    }
  }, [open]);
  useEffect(() => {
    if (!open) return;

    const handlePhysicalKey = (e) => {
      if (isProcessing) return;

      const key = e.key;

      // Backspace → delete
      if (key === "Backspace") {
        e.preventDefault();
        handleKeyPress("←");
        return;
      }

      // Enter → validate
      if (key === "Enter") {
        e.preventDefault();
        handleKeyPress("✔");
        return;
      }

      // Allow numbers and letters
      if (/^[a-zA-Z0-9]$/.test(key)) {
        e.preventDefault();
        handleKeyPress(key);
      }
    };

    window.addEventListener("keydown", handlePhysicalKey);

    return () => {
      window.removeEventListener("keydown", handlePhysicalKey);
    };
  }, [open, pin, isProcessing]);
  const [token, setToken] = useToken();

  const handleKeyPress = async (key) => {
    if (isProcessing) return;
    setHasError(false); // Reset error state on new key press

    if (key === "←") {
      setPin(pin.slice(0, -1));
    } else if (key === "✔") {
      if (pin.length === 0) {
        toast.error("Veuillez entrer un code badge");
        return;
      }

      setIsProcessing(true);
      try {
        const response = await unlock(null, null, pin);

        // Check if response is successful based on your API structure
        if (response.data && response.data.data) {
          const token = response.data.data.token;
          setToken(token);
          localStorage.setItem("locked", "false");
          handleClose();
          if (parametrages?.TableRequired) openModalTables(true);
          window.location.reload();
        } else {
          // If API returns success but no data (wrong PIN)
          throw new Error("Invalid PIN");
        }
      } catch (error) {
        // --- THE REACTION ---
        setHasError(true);
        setPin(""); // Clear PIN on error so they can retry
        toast.error("Code badge incorrect");
        console.error("Login error:", error);
      } finally {
        setIsProcessing(false);
      }
    } else if (pin.length < 50) {
      setPin(pin + key);
    }
  };

  const handleClose = () => {
    if (!isProcessing) {
      setPin("");
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "90%",
          maxWidth: 475,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",// Apply shake animation if hasError is true
          animation: hasError ? `${shake} 0.4s ease-in-out` : "none",
          border: hasError ? "2px solid #d32f2f" : "none", // Optional red border on error
        }}
        className="relogin-modal"
      >
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: 3, width: "100%" }}>
          <Typography variant="h5" color={hasError ? "error" : "inherit"}>
            <i className={`fas ${hasError ? "fa-lock-open" : "fa-lock"}`}></i>
            {hasError ? " Code Incorrect" : " Caisse verrouillée"}
          </Typography>
        </Box>

        {/* PIN Display */}
        <Box
          sx={{
            width: "100%",
            mb: 3,
            p: 2,
            bgcolor: hasError ? "#ffebee" : "#f5f5f5", // Light red background on error
            borderRadius: 1,
            textAlign: "center",
            transition: "background-color 0.3s ease",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              letterSpacing: 3,
              fontFamily: "monospace",
              color: hasError ? "#d32f2f" : (pin.length === 0 ? "#999" : "#333"),
              minHeight: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {pin.length > 0 ? "•".repeat(pin.length) : "Code badge..."}
          </Typography>
        </Box>

        {/* Processing Indicator */}
        {isProcessing && (
          <Box sx={{ mb: 2, width: "100%", textAlign: "center" }}>
            <Typography variant="body2" color="primary">
              Vérification en cours...
            </Typography>
          </Box>
        )}

        {/* Virtual Keyboard */}
        <Box sx={{ width: "100%", mb: 3 }}>
          <KeyboardComponent
            onKeyPress={handleKeyPress}
            showLetters={showLetters}
            setShowLetters={setShowLetters}
            disabled={isProcessing}
            compact={true}
            context="login"
          />
        </Box>

        {/* Actions */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
            width: "100%",
          }}
        >
          {/* <Button
            onClick={handleClose}
            color="inherit"
            disabled={isProcessing}
            variant="outlined"
          >
            Annuler
          </Button> */}
        </Box>
      </Box>
    </Modal>
  );
}

export default ReloginModal;
